
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { DocumentForm } from '@/forms/DocumentForm'
import { Settings } from '@/interfaces/Settings'

export default function ExpenseDetailPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'expense',
  })
  const { data: documentData, isLoading: invoicesLoading } = useSWR(
    id && `/api/v2/expenses/${id}`,
    apiFetcher,
  )
  const { data: settings, isLoading } = useSWR<Settings>(`/api/v2/settings`, apiFetcher)
  const title = `${t('edit.title')} ${id}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/expenses',
        children: t('list.title'),
      },
      {
        href: `/expense/${id}`,
        children: id as string,
      },
    ],
  })

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <title>{title}</title>

      {(invoicesLoading) && <Loading />}

      {documentData && (
        <DocumentForm
          type="expense"
          documentData={documentData}
          settings={settings!}
        />
      )}
    </>
  )
}
